const isPlainObject = (value) => {
  if (!value || typeof value !== "object") return false;

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

export const stripUndefinedValues = (value) => {
  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== undefined)
      .map((item) => stripUndefinedValues(item));
  }

  if (!isPlainObject(value)) return value;

  return Object.entries(value).reduce((cleanValue, [key, item]) => {
    if (item !== undefined) {
      cleanValue[key] = stripUndefinedValues(item);
    }
    return cleanValue;
  }, {});
};
